import { gql } from '@apollo/client';

export const GET_TAGS = gql`
  query GetTags($page: Int!, $perPage: Int!, $search: String!, $activeOnly: Boolean!, $advancedFilters: [JSON!]) {
    tags(page: $page, perPage: $perPage, search: $search, activeOnly: $activeOnly, advancedFilters: $advancedFilters) {
      totalCount
      edges {
        node {
          id
          name
          internalId
          active
          fontColor
          backgroundColor
          customersCount
          createdAt
        }
      }
    }
  }
`;

export const GET_TAG = gql`
  query GetTag($id: ID!) {
    tag(id: $id) {
      id
      name
      internalId
      active
      fontColor
      backgroundColor
      customersCount
    }
  }
`;

export const CREATE_TAG = gql`
  mutation CreateTag($input: TagAttributes!) {
    createTag(input: { attributes: $input }) {
      tag {
        id
        name
        internalId
        active
        fontColor
        backgroundColor
      }
      errors
    }
  }
`;

export const UPDATE_TAG = gql`
  mutation UpdateTag($id: ID!, $input: TagAttributes!) {
    updateTag(input: { id: $id, attributes: $input }) {
      tag {
        id
        name
        internalId
        active
        fontColor
        backgroundColor
      }
      errors
    }
  }
`;

export const UPDATE_TAG_STATUS = gql`
  mutation UpdateTagStatus($id: ID!, $active: Boolean!) {
    updateTagStatus(input: { id: $id, active: $active }) {
      tag {
        id
        active
      }
      errors
    }
  }
`;

export const SEARCH_TAGS = gql`
  query SearchTags($query: String!) {
    searchTags(query: $query) {
      id
      name
      internalId
      active
      fontColor
      backgroundColor
      customersCount
      customersWithWhatsappCount
    }
  }
`; 